import React, { useEffect, useState } from 'react';
import s from './CalendarGrid.module.css';

interface CurrentTimeLineProps {
    /** Day window in minutes (from dayStart "HH:mm" → minutes since midnight). */
    dayStartMinutes: number;
    dayEndMinutes: number;
    pixelsPerMinute: number;
    /** Only renders the line if the viewed date matches today's local date. */
    isToday: boolean;
}

/**
 * AB#1749 — Horizontal red line indicating the current time on the
 * calendar grid. Re-renders once a minute. Only visible when the user
 * is viewing today AND the current local time falls within the day's
 * working window.
 */
const CurrentTimeLine: React.FC<CurrentTimeLineProps> = ({
    dayStartMinutes, dayEndMinutes, pixelsPerMinute, isToday,
}) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        if (!isToday) return;
        const id = window.setInterval(() => setNow(new Date()), 60_000);
        return () => window.clearInterval(id);
    }, [isToday]);

    if (!isToday) return null;

    const minutes = now.getHours() * 60 + now.getMinutes();
    if (minutes < dayStartMinutes || minutes > dayEndMinutes) return null;

    const top = (minutes - dayStartMinutes) * pixelsPerMinute;

    return (
        <div
            className={s.currentTimeLine}
            style={{ top: `${top}px` }}
            aria-hidden="true"
        >
            <span className={s.currentTimeDot} />
        </div>
    );
};

export default CurrentTimeLine;
